import { MAP_TYPES } from '@deck.gl/carto';

const HIGH_RISK_NETWORK_SOURCE_ID = 'highRiskNetworkSource';

const source = {
  id: HIGH_RISK_NETWORK_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT street_nm as Street_Name, Total_Lanes, FUNCLASS_I, Speed, HRN_Score, geom FROM us-con-gcp-npr-0000424-011325.diamond.BSAP_High_Risk_Network',
};

export default source;
